import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  name: 'FeedbackPage',
  components: { VueSlickCarousel },
  data() {
    return {
      carouselSettings: {
        dots: true,
        arrows: false,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
      },
      categories_options: [],
      category: '',
      files: [],
      documents: [],
      valid: false,
      name: '',
      email: '',
      phone: '',
      message: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        phoneLength: value => (!value || value.length >= 17) || 'Номер телефона заполнен не полностью',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
        maxFiles: () => this.files.length < 5 || 'Количество файлов не более 5',
      },
      formData: {
        city_id: null,
      },
      cities: [],
      searchCity: '',
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    loading() { return this.$store.state.loading; },
    isEnabled() { return !!this.name && !!this.email && !!this.phone && !!this.message; },
    maxSize() {
      if (this.files.length) {
        return this.files.reduce((acc, f) => acc + f.size, 0) < 6000000 || 'Размер файлов больше 6Мбт';
      }
      return true;
    },
  },
  watch: {
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
  },
  methods: {
    /** Получить категории формы обратной связи */
    GetFeedbackCategories() {
      const app = this;
      app.$store.getters.ax.post('feedback/api/feedback/feedback-categories')
        .then((response) => {
          if (response.data.categories) {
            app.categories = response.data.categories;
            app.categories_options = app.SetFormThemes(response.data.categories);
            app.category = response.data.categories.length ? response.data.categories[0].name : '';
          }
        });
    },
    /** Получить темы формы */
    SetFormThemes(category) {
      return category.map(item => item.name);
    },
    GetBase64() {
      this.files.forEach((f) => {
        this.TransformFile(f);
      });
    },
    /** Методы для работы с документами */
    async TransformFile(file) {
      const app = this;
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.url = fr.result;
        app.documents.push(document);
      });
      return document;
    },
    /** Получить ID категории */
    GetCategoryID() {
      const arr = this.categories.filter(item => item.name === this.category);
      return arr[0].id;
    },
    /** Отправить данные формы обратной связи */
    FeedbackSubmit() {
      const app = this;
      if (app.valid) {
        const feedback = {
          name: app.name,
          email: app.email,
          phone_mobile_local: app.phone,
          content: app.message,
        };
        if (app.isAuthenticated) {
          feedback.profile_id = app.user.profile_id;
        }
        if (app.documents.length) {
          feedback.documents = app.documents;
        }
        feedback.category_id = app.category ? app.GetCategoryID() : null;

        app.$store.getters.axl.post('feedback/api/feedback/feedback', feedback)
          .then(() => {
            app.$refs.feedbackForm.reset();
            app.$refs.feedbackForm.resetValidation();
            app.$store.dispatch('ShowInfo', 'Ваше сообщение успешно отправлено');
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      }
    },
    /** Сбросить поля формы */
    ResetForm() {
      this.name = '';
      this.phone = '';
      this.email = '';
      this.message = '';
    },
  },
  mounted() {
    this.GetFeedbackCategories();
    this.$store.dispatch('SetTitle', 'Помощь');
  },
};
